import React, { Component } from "react";
import { CompanyFormContainer } from "../containers";
import { Header } from "../components/header";
export class CompanyForm extends Component {
  constructor(props) {
    super();
  }

  render() {
    return (
      <div>
        <Header />
        <div className="container">
          <CompanyFormContainer companyID={this.props.match.params.companyID} />
        </div>
      </div>
    );
  }
}
